







































import { Vue, Component } from "vue-property-decorator";
import ClaimUpdateRequestListComponent from "@/components/vcponlineok/staff-user/claim-update-request-list-component.vue";
import ClaimUpdateRequestComponent from "@/components/vcponlineok/staff-user/claim-update-request-component.vue";
import ClaimViewBaseComponent from "./ClaimViewBaseComponent";
import {
  VcSubmissionDtoOfVcClaimUpdateRequestDto,
  IVcSubmissionDtoOfVcClaimUpdateRequestDto
} from "@/asdcom/apiproxy/apiproxy.dto";
import { IHeader } from "@/store/models/staff/IHeader";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({
  components: {
    ClaimUpdateRequestListComponent,
    ClaimUpdateRequestComponent
  }
})
export default class UpdateRequests extends ClaimViewBaseComponent {
  isItemView: boolean = false;
  viewModel: VcSubmissionDtoOfVcClaimUpdateRequestDto[] = [];
  componentModel: IVcSubmissionDtoOfVcClaimUpdateRequestDto | undefined;
  headers: IHeader[] = [
    { text: "Submitted Date", value: "creationTime", align: "center" },
    { text: "Status", value: "workItemPublicStatus", align: "center" },
    { text: "Sections", value: "submissionData", align: "center", width: "350" }
  ];

  created() {
    this.getUpdateRequests();
  }

  mounted() {
    bus.$on("toListView", () => {
      this.isItemView = false;
    });
  }
  destroyed() {
    bus.$off("toListView");
  }

  async getUpdateRequests() {
    this.viewModel = await this.$appsvs.vcpOnlineOkStaff.retrieveVcClaimUpdateRequests(
      this.vcClaimNumber
    );
  }
  onRequestItemClick(item: VcSubmissionDtoOfVcClaimUpdateRequestDto) {
    this.componentModel = this.viewModel.find(i => i.id == item.id);
    this.isItemView = true;
  }

  onCloseItemView() {
    this.getUpdateRequests();
    this.isItemView = false;
  }
}
